// extracted by mini-css-extract-plugin
export default {"campaign-table":"CampaignManager_campaign-table__rt85m","ant-table-cell":"CampaignManager_ant-table-cell__IMu5C"};